const PaymentInstallmentsForGetContractWhere = [ 'dueDate' ];

export { PaymentInstallmentsForGetContractWhere };
